export default __webpack_public_path__ + "static/media/NIAS0370.34I-32957_-17948_0.a119ef27.jpg";